import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AnimatePresence } from 'framer-motion';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import HeroWithPaths from '../components/HeroWithPaths';
import WhatWeBuild from '../components/WhatWeBuild';
import AboutSection from '../components/AboutSection';
import ProjectsSection from '../components/ProjectsSection';
import StudentsSection from '../components/StudentsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import Preloader from '../components/ui/Preloader';
import SEO from '../components/SEO';

const Home = () => {
  const [projects, setProjects] = useState([]);
  const [students, setStudents] = useState([]);
  const [preloaderFinished, setPreloaderFinished] = useState(false);

  // Safety fallback: ensure preloader doesn't keep the app blank
  useEffect(() => {
    const safety = setTimeout(() => {
      if (!preloaderFinished) {
        console.warn('Home: Preloader safety timeout triggered');
        setPreloaderFinished(true);
      }
    }, 5000); // fallback after 5s
    return () => clearTimeout(safety);
  }, [preloaderFinished]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('/api/home-data');
        setProjects(response.data.projects || []);
        setStudents(response.data.students || []);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <SEO
        title="SDC – Student Projects & Innovation"
        description="Browse featured software projects and meet the students building technology at the Student Development Cell."
        canonical="https://sdc.mitsgwalior.in/"
      />
      <AnimatePresence mode="wait">
        {!preloaderFinished && (
          <Preloader onComplete={() => {
            console.log("Home: Preloader completed");
            setPreloaderFinished(true);
          }} />
        )}
      </AnimatePresence>

      {preloaderFinished && (
        <>
          <Navbar />
          <HeroWithPaths />
          <AboutSection />
          <ProjectsSection projects={projects} />
          <StudentsSection students={students} />
          <WhatWeBuild />
          <Hero />
          <ContactSection />
          <Footer />
        </>
      )}
    </div>
  );
};

export default Home;
